import { debugError, debugLog } from "../utils";

// extractErrorMessage reads the message off an error body. Migrated routes
// answer the unified envelope {"error": {"code", "message", "details",
// "request_id"}} (pkg/errors, ADR-0032); legacy routes still answer
// {"message": ...} or {"error": "..."} until they are migrated (COI-779).
export function extractErrorMessage(errorBody) {
  if (!errorBody) return "";
  const envelope = errorBody.error;
  if (envelope && typeof envelope === "object" && envelope.message) {
    return envelope.message;
  }
  if (errorBody.message) return errorBody.message;
  if (typeof envelope === "string") return envelope;
  return "";
}

// codedError builds an Error carrying the envelope's code and request id so
// callers can branch on error.code and quote error.requestId to support.
function codedError(message, errorBody) {
  const err = new Error(message);
  const envelope = errorBody && errorBody.error;
  if (envelope && typeof envelope === "object") {
    err.code = envelope.code;
    err.details = envelope.details;
    err.requestId = envelope.request_id;
  }
  return err;
}

class HttpService {

 replacer(_, value) {
    if (typeof value === 'bigint') {
        return value.toString();
    }
    return value;
  }

  // async get(url) {
  //   try {
  //     const response = await fetch(url);
  //     return await this.processResponse(response);
  //   } catch (error) {
  //     // Handle or throw the error as needed
  //     debugError('GET request error:', error.message);
  //     throw error;
  //   }
  // }

  async post(url, data) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data, this.replacer),
      });
      return await this.processResponse(response);
    } catch (error) {
      // Handle or throw the error as needed
      debugError('POST request error:', error.message);
      throw error;
    }
  }

  // unused
  // async postWithTimeout(url, data, timeout = 1000) {
  //   const controller = new AbortController();
  //   const timeoutId = setTimeout(() => controller.abort(), timeout);

  //   try {
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       signal: controller.signal,
  //       headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  //       body: JSON.stringify(data),
  //     });
  //     clearTimeout(timeoutId);
  //     return await this.processResponse(response);
  //   } catch (error) {
  //     clearTimeout(timeoutId);
  //     // Handle or throw the error as needed
  //     debugError('POST request with timeout error:', error.message);
  //     throw error;
  //   }
  // }

  async processResponse(response) {
    if (!response.ok) {

      let errorBody = {};
      try {
        errorBody = await response.json();
      } catch (parseError) {
        debugError('Failed to parse error response body:', parseError.message);
      }

      if (errorBody.type && errorBody.type=="html") {
        return errorBody; //sent html error back
      }

      // Catalog error envelope: the backend ships a server-rendered turbo
      // stream (error card / full page / banner) alongside the error key.
      if (errorBody.error_html) {
        Turbo.renderStreamMessage(errorBody.error_html);
        const renderedError = codedError(extractErrorMessage(errorBody) || errorBody.error_key || 'Checkout error', errorBody);
        renderedError.errorKey = errorBody.error_key;
        renderedError.surfaceRendered = true;
        throw renderedError;
      }

      const errorMessage = extractErrorMessage(errorBody) || 'Unknown error occurred';
      throw codedError(errorMessage, errorBody);
    }
    return await response.json();
  }
}

const httpService = new HttpService();
export default httpService;